/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts
 */

import { FieldType } from "../../type-system/FieldType";
import { ShopifyCarrierServiceKey, ShopifyCarrierServiceToShopKey, ShopifyShopKey } from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyCarrierServiceKey,
  "2022-01": {
    name: "Shopify Carrier Service",
    fields: [
      {
        name: "Active",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "active" } },
      },
      {
        name: "Callback URL",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "callback_url" } },
      },
      {
        name: "Carrier Service Type",
        fieldType: FieldType.Enum,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "carrier_service_type" } },
        configuration: {
          allowMultiple: false,
          options: [{ name: "legacy" }, { name: "api" }],
        },
      },
      {
        name: "Format",
        fieldType: FieldType.Enum,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "format" } },
        configuration: {
          default: "json",
          allowMultiple: false,
          options: [{ name: "json" }, { name: "xml" }],
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name" } },
      },
      {
        name: "Service Discovery",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "service_discovery" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCarrierServiceToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "carrierService" },
  },
  "2025-04": {
    graphQLTypename: "DeliveryCarrierService",
    fields: [
      {
        name: "Active",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "active", graphQLFieldKey: "active" } },
      },
      {
        name: "Callback URL",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "callback_url", graphQLFieldKey: "callbackUrl" } },
      },
      {
        name: "Carrier Service Type",
        fieldType: FieldType.Enum,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "carrier_service_type" } },
        configuration: {
          allowMultiple: false,
          options: [{ name: "legacy" }, { name: "api" }],
        },
        isDeleted: true,
      },
      {
        name: "Format",
        fieldType: FieldType.Enum,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "format" } },
        configuration: {
          default: "json",
          allowMultiple: false,
          options: [{ name: "json" }, { name: "xml" }],
        },
        isDeleted: true,
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id" } },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name", graphQLFieldKey: "name" } },
      },
      {
        name: "Service Discovery",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "service_discovery", graphQLFieldKey: "supportsServiceDiscovery" },
        },
      },
      {
        name: "Formatted Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "formattedName" } },
      },
      {
        name: "Icon",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "icon",
            graphQLSelection: `
          id
          height
          width
          url
          altText
          `,
          },
        },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "carrierServices",
      filters: {},
    },
  },
};

export const ShopifyCarrierService = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
